module.exports = __webpack_public_path__ + "static/logo-white-876c9a8284bfdf03fa414489643b9a2c.png";